import { ArrowUpRight, Phone, MessageSquare } from "lucide-react";

// Single fixed bottom bar on every page.
// Phones (<=768px): three equal-width buttons in one row — Quote / Call / Text.
// Tablets & desktops (>768px): one Request a Quote button.
// The trailing spacer keeps the fixed bar from covering page-bottom content.
export const BottomBar = () => (
  <>
    <div
      data-testid="bottom-bar-mobile"
      className="min-[769px]:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-3 border-t border-white/10"
    >
      <a
        href="/#quote"
        data-testid="bottom-bar-quote"
        className="inline-flex items-center justify-center gap-1.5 bg-[#FF4500] text-[#1C1C1C] font-bold text-sm py-3.5 whitespace-nowrap"
      >
        Quote
        <ArrowUpRight className="h-4 w-4" strokeWidth={2} />
      </a>
      <a
        href="tel:+19729476017"
        data-testid="bottom-bar-call"
        className="inline-flex items-center justify-center gap-1.5 bg-[#262626] text-white font-semibold text-sm py-3.5 whitespace-nowrap"
      >
        <Phone className="h-4 w-4" strokeWidth={1.75} />
        Call
      </a>
      <a
        href="sms:+19729476017?&body=Hi%2C%20I%27d%20like%20a%20moving%20quote."
        data-testid="bottom-bar-text"
        className="inline-flex items-center justify-center gap-1.5 bg-[#303030] text-white font-semibold text-sm py-3.5 whitespace-nowrap"
      >
        <MessageSquare className="h-4 w-4" strokeWidth={1.75} />
        Text
      </a>
    </div>
    <a
      href="/#quote"
      data-testid="bottom-bar-quote-desktop"
      className="hidden min-[769px]:inline-flex fixed bottom-4 inset-x-4 z-40 items-center justify-center gap-2 bg-[#FF4500] text-[#1C1C1C] font-bold px-6 py-4 text-base shadow-lg shadow-black/40 hover:bg-[#E03C00] transition-colors"
    >
      Request a Quote
      <ArrowUpRight className="h-5 w-5" strokeWidth={2} />
    </a>
    <div aria-hidden="true" className="h-16 md:h-24" />
  </>
);
